import { render, staticRenderFns } from "./ContractorBuildingList.vue?vue&type=template&id=53987c82&scoped=true&"
import script from "./ContractorBuildingList.vue?vue&type=script&lang=js&"
export * from "./ContractorBuildingList.vue?vue&type=script&lang=js&"
import style0 from "./ContractorBuildingList.vue?vue&type=style&index=0&id=53987c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53987c82",
  null
  
)

export default component.exports